'use es6';

export const LAYOUT_SECTION_TRACKING = {
  ADD_MODULE_FROM_SIDEBAR: 'ADD_MODULE_FROM_SIDEBAR',
  DRAGGED_LAYOUT_ITEM: 'DRAGGED_LAYOUT_ITEM',
  COLUMN_RESIZE: 'COLUMN_RESIZE',
  DELETE_MODULE: 'DELETE_MODULE',
  EDIT_MODULE: 'EDIT_MODULE',
  EDIT_GLOBAL_CONTENT: 'EDIT_GLOBAL_CONTENT',
  CLONE_ROW: 'CLONE_ROW',
  CLONE_CELL: 'CLONE_CELL',
  CLONE_COLUMN: 'CLONE_COLUMN',
  EDIT_LAYOUT_STYLES: 'EDIT_LAYOUT_STYLES',
  DELETE_COLUMN: 'DELETE_COLUMN',
  DELETE_ROW: 'DELETE_ROW',
  HIDE_MODULE: 'HIDE_MODULE',
  HIDE_ROW: 'HIDE_ROW',
  HIDE_COLUMN: 'HIDE_COLUMN',
  HIDE_SECTION: 'HIDE_SECTION',
  ADDED_EMBED_FROM_SIDEBAR: 'ADDED_EMBED_FROM_SIDEBAR',
  ADDED_DEVELOPER_SECTION_FROM_SIDEBAR: 'ADDED_DEVELOPER_SECTION_FROM_SIDEBAR',
  ADDED_DEVELOPER_SECTION_FROM_LIBRARY_MODAL: 'ADDED_DEVELOPER_SECTION_FROM_LIBRARY_MODAL',
  ADDED_SAVED_SECTION_FROM_SIDEBAR: 'ADDED_SAVED_SECTION_FROM_SIDEBAR',
  ADDED_SAVED_SECTION_FROM_LIBRARY_MODAL: 'ADDED_SAVED_SECTION_FROM_LIBRARY_MODAL',
  ADDED_EMBED_FROM_LIBRARY_MODAL: 'ADDED_EMBED_FROM_LIBRARY_MODAL',
  ADDED_LAYOUT_FROM_SIDEBAR: 'ADDED_LAYOUT_FROM_SIDEBAR',
  CLONE_NESTED_MODULE: 'CLONE_NESTED_MODULE',
  DELETE_NESTED_MODULE: 'DELETE_NESTED_MODULE',
  EDIT_NESTED_MODULE: 'EDIT_NESTED_MODULE',
  CLICKED_ADD_SECTION_BUTTON: 'CLICKED_ADD_SECTION_BUTTON',
  SWAP_FOOTER: 'SWAP_FOOTER',
  SWAP_HEADER: 'SWAP_HEADER',
  EDIT_HEADER: 'EDIT_HEADER',
  EDIT_FOOTER: 'EDIT_FOOTER'
};
export const LAYOUT_SECTION_TRACKING_MESSAGES = {
  ADD_MODULE_FROM_SIDEBAR: 'item-added-from-sidebar',
  DRAGGED_LAYOUT_ITEM: 'dragged-item',
  COLUMN_RESIZE: 'column-resize',
  DELETE_MODULE: 'deleted-module',
  EDIT_GLOBAL_CONTENT: 'edit-global-content',
  EDIT_MODULE: 'edit-module',
  CLONE_ROW: 'cloned-row',
  CLONE_CELL: 'cloned-cell',
  CLONE_COLUMN: 'cloned-column',
  EDIT_LAYOUT_STYLES: 'edit-layout-styles',
  DELETE_COLUMN: 'delete-column',
  DELETE_ROW: 'delete-row',
  HIDE_MODULE: 'hide-module',
  HIDE_ROW: 'hide-row',
  HIDE_COLUMN: 'hide-column',
  HIDE_SECTION: 'hide-section',
  ADDED_EMBED_FROM_SIDEBAR: 'embed-added-from-sidebar',
  ADDED_DEVELOPER_SECTION_FROM_SIDEBAR: 'developer-section-added-from-sidebar',
  ADDED_DEVELOPER_SECTION_FROM_LIBRARY_MODAL: 'developer-section-added-from-library-modal',
  ADDED_SAVED_SECTION_FROM_SIDEBAR: 'saved-section-added-from-sidebar',
  ADDED_SAVED_SECTION_FROM_LIBRARY_MODAL: 'saved-section-added-from-library-modal',
  ADDED_EMBED_FROM_LIBRARY_MODAL: 'embed-added-from-library-modal',
  ADDED_LAYOUT_FROM_SIDEBAR: 'layout-added-from-sidebar',
  CLONE_NESTED_MODULE: 'cloned-nested-module',
  DELETE_NESTED_MODULE: 'deleted-nested-module',
  EDIT_NESTED_MODULE: 'edit-nested-module',
  CLICKED_ADD_SECTION_BUTTON: 'clicked-add-section-button',
  SWAP_FOOTER: 'swap-footer',
  SWAP_HEADER: 'swap-header',
  EDIT_HEADER: 'edit-header',
  EDIT_FOOTER: 'edit-footer'
};
export const DRAG_AND_DROP_AREA_ACTION = 'Drag And Drop Area Action';